import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { CURRICULUM } from "@/lib/curriculum";
import { MOODS, MOOD_DOT, posterFor } from "@/lib/journey";

const tileBorder = (done, current) => {
  if (current) return "border-[#F59E0B] shadow-[0_0_0_1px_rgba(245,158,11,0.5)]";
  if (done) return "border-emerald-400/50";
  return "border-[#E7DFD5] hover:border-[#E7DFD5]";
};

function Tile({ m, done, current }) {
  return (
    <Link
      to={`/modules/${m.id}/experience`}
      data-testid={`journey-tile-${m.id}`}
      className={`group relative block aspect-[3/4] overflow-hidden border transition-colors duration-500 ${tileBorder(done, current)}`}
    >
      <img
        src={posterFor(m.id)}
        alt={`Module ${m.n} scene`}
        loading="lazy"
        className={`absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${done ? "opacity-50" : "opacity-90"}`}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
      <span className={`absolute top-2 left-2 w-1.5 h-1.5 rounded-full ${MOOD_DOT[MOODS[m.id]]}`} />
      {done && (
        <CheckCircle2 size={14} className="absolute top-2 right-2 text-emerald-400" data-testid={`journey-tile-done-${m.id}`} />
      )}
      {current && (
        <span className="absolute top-1.5 right-2 font-mono text-[9px] tracking-[0.2em] uppercase text-[#B45309]" data-testid="journey-tile-current">
          Next
        </span>
      )}
      <div className="absolute bottom-2 left-2 right-2">
        <div className="font-display text-xl md:text-2xl leading-none text-[#1C1917]">{m.n}</div>
        <div className="font-mono text-[8px] md:text-[9px] tracking-[0.12em] uppercase text-[#44403C] truncate mt-1">{m.title}</div>
      </div>
    </Link>
  );
}

export const JourneyStrip = ({ completed = [], currentId = null, className = "" }) => (
  <section data-testid="journey-strip" className={`relative ${className}`}>
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-5">
      <div>
        <div className="section-tag mb-2">§ The Journey</div>
        <h3 className="font-display text-3xl md:text-4xl tracking-tight leading-none">
          Through <span className="italic text-red-400/90">Adversity</span> comes <span className="italic text-emerald-300">Change</span>.
        </h3>
      </div>
      <p className="text-[#78716C] text-sm max-w-sm md:text-right">
        Eight scenes, storm to sunrise. The world behind Rich changes as his words land.
      </p>
    </div>
    <div className="h-px w-full bg-gradient-to-r from-red-500/80 via-[#F59E0B]/80 to-emerald-400/80 mb-4" />
    <div className="grid grid-cols-4 md:grid-cols-8 gap-2 md:gap-3">
      {CURRICULUM.map((m) => (
        <Tile key={m.id} m={m} done={completed.includes(m.id)} current={m.id === currentId} />
      ))}
    </div>
    <div className="flex justify-between mt-3 font-mono text-[10px] tracking-[0.3em] uppercase">
      <span className="text-red-400/80">Adversity</span>
      <span className="text-[#B45309]/80">Ground</span>
      <span className="text-emerald-300/80">Change</span>
    </div>
  </section>
);
